<template>
    <div class="coldContainer" :class="{'coldContainerDark' : isDark}">
        <TitleBar title="冷门分析" :txt="txt" :type="type"></TitleBar>
        <div class="coldBox">
            <div class="coldCard left" @click="goModelList">
                <p>{{coldLeft.home_team}}</p>
                <p>{{coldLeft.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: coldLeft.sclass_color}">{{coldLeft.sclass_name}}</span>
                    <span class="time">{{matchTimeLeft}}</span>
                </div>
                <div class="result">
                    <p v-if="coolData.is_pay === 0" class="val">{{Math.round(coldLeft.hit_odds*100)}}%</p>
                    <p v-else>
                        <ChartsPie
                            id="coldPieLeft"
                            :colors = "['#FF5048',isDark ? '#2f2f2f':'#eeeeee']"
                            :data="[coldLeft.cold*1, 100 - coldLeft.cold*1]"
                            type="cold"
                            :text="coldLeft.cold*1 + '%'"
                        />
                    </p>
                    <p v-if="coolData.is_pay === 0">命中冷门高赔</p>
                    <p v-else>冷门指数</p>
                </div>
            </div>
            <div class="coldCard" @click="goModelList">
                <p>{{coldRight.home_team}}</p>
                <p>{{coldRight.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: coldRight.sclass_color}">{{coldRight.sclass_name}}</span>
                    <span class="time">{{matchTimeRight}}</span>
                </div>
                <div class="result">
                    <p v-if="coolData.is_pay === 0" class="val">{{Math.round(coldRight.hit_odds*100)}}%</p>
                    <p v-else>
                        <ChartsPie
                            id="coldPieRight"
                            :colors = "['#FF5048',isDark ? '#2f2f2f':'#eeeeee']"
                            :data="[coldRight.cold*1, 100 - coldRight.cold*1]"
                            type="cold"
                            :text="coldRight.cold*1 + '%'"
                        />
                    </p>
                    <p v-if="coolData.is_pay === 0">命中冷门高赔</p>
                    <p v-else>冷门指数</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from '../datamodel/common/titleBar.vue'
import ChartsPie from './common/chartsPie.vue'
export default {
    name: 'coldAnalysisCorpus',
    props: ['coolData'],
    components: {
        TitleBar,
        ChartsPie
    },
    watch: {
        data: {
            handler () {
                this.renderColdList();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "18",
            txt: '',
            coldLeft: {},
            coldRight: {},
            matchTimeLeft: '',
            matchTimeRight: ''
        }
    },
    methods: {
        renderColdList () {
            if (this.coolData) {
                this.coldLeft = this.coolData.list[0];
                this.coldRight = this.coolData.list[1];
                this.matchTimeLeft = this.coolData.list[0].match_time.substring(5, 16).replace('-', '月');
                this.matchTimeRight = this.coolData.list[1].match_time.substring(5, 16).replace('-', '月');
                if (this.coolData.type_num * 1 > 0) {
                    this.txt = '（七日成功抓冷' + this.coolData.type_num + '场）';
                } else {
                    this.txt = '';
                }
            }
        },
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>

<style lang="less">
.coldContainer{
    width: 100%;
    .coldBox{
        width: 100%;
        padding: 0 14px;
        overflow: hidden;
        .coldCard{
            position: relative;
            display: inline-block;
            width: 48%;
            height: auto;
            padding: 10px 10px 0;
            background: #FFFFFF;
            border-radius: 5px;
            text-align: left;
            &.left{
                margin-right: 4%;
            }
            >p{
                margin-bottom: 8px;
                font-size: 12px;
                font-weight: bold;
                color: #333333;
                max-width: 90px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.margin{
                    position: relative;
                    width: 70px;
                    max-width: 70px;
                    padding-right: 5px;
                    span{
                        position: absolute;
                        right: 0;
                        font-size: 13px;
                        font-weight: bold;
                        color: #FF5048;
                    }
                }
            }
            .btm{
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                font-size: 10px;
                border-top: 1px solid #EEEEEE;
                .league{
                    float: left;
                    height: 30px;
                    color: #BE2FD1;
                }
                .team{
                    color: #333333;
                    em{
                        color: #FF5048;
                    }
                }
                .time{
                    float: right;
                    height: 30px;
                    color: #999999;
                }
            }
            .result{
                position: absolute;
                top: 7px;
                right: 6px;
                font-size: 10px;
                color: #333333;
                text-align: center;
                >p{
                    font-weight: normal;
                }
                .val{
                    font-size: 20px;
                    font-weight: bold;
                    color: #FF5048;
                    &.margin{
                        font-size: 15px;
                        margin-top: 8px;
                    }
                }
                .odds{
                    height: 36px;
                    img{
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                    }
                }
            }
        }
    }
}
.coldContainerDark {
    background-color: #191919;
    .coldBox {
        .coldCard {
            background: #232323;
            >p {
                color: #d3d3d3;
            }
            .result {
                color: #d3d3d3;
            }
            .btm {
                border-color: #2f2f2f;
                .team {
                    color: #d3d3d3;
                }
                .time {
                    color: #a6a6a6;
                }
            }
        }
    }
}
</style>
